import { Action } from '@ngrx/store';

export enum ReportsActionTypes {
    ExportPurchaseSummarySuplier = '[Reports] Export purchase summary supplier',
    ExportPurchaseSummary = '[Reports] Export purchase summary',
    ExportPurchaseSummaryFail = '[Reports] Export purchase summary fail',
    ExportPurchaseSummarySuccess = '[Reports] Export purchase summary success',

    ExportProformaList = '[Proforma] Export proforma list',
    ExportProformaListSuccess = '[Proforma] Export proforma list success',
    ExportProformaListFail = '[Proforma] Export proforma list fail',

    GetUploadLink = '[Proforma] get upload file link',
    GetUploadLinkSuccess = '[Proforma] upload file link success',
    GetUploadLinkFail = '[Proforma] upload file link fail',

    GetUploadLinkNew = '[Proforma] get upload file link new',
    GetUploadLinkNewSuccess = '[Proforma] upload file link new success',
    GetUploadLinkNewFail = '[Proforma] upload file link new fail',
   
    GetUploadLinkNewDetailProformas = '[Proforma] get upload file link new detail proformas',
    GetUploadLinkNewDetailProformasSuccess = '[Proforma] upload file link new detail proformas success',
    GetUploadLinkNewDetailProformasFail = '[Proforma] upload file link new detail proformas fail',

    GetUploadLinkShippingTimes = '[Proforma] get upload file link shipping times',
    GetUploadLinkShippingTimesSuccess = '[Proforma] upload file link shipping times success',
    GetUploadLinkShippingTimesFail = '[Proforma] upload file link shipping times fail',

    GetUploadLinkPort = '[Proforma] get upload file link port',
    GetUploadLinkPortSuccess = '[Proforma] upload file link port success',
    GetUploadLinkPortFail = '[Proforma] upload file link port fail',

    UploadFile = '[Proforma] upload file',
    UploadFileSuccess = '[Proforma] upload file success',
    UploadFileFail = '[Proforma] upload file fail',

    UploadFileNew = '[Proforma] upload file new',
    UploadFileNewSuccess = '[Proforma] upload file new success',
    UploadFileNewFail = '[Proforma] upload file new fail',

    UploadFileNewDetailProformas = '[Proforma] upload file new detail proformas',
    UploadFileNewDetailProformasSuccess = '[Proforma] upload file new detail proformas success',
    UploadFileNewDetailProformasFail = '[Proforma] upload file new detail proformas fail',

    UploadFileShippingTimes = '[Proforma] upload file shipping times',
    UploadFileShippingTimesSuccess = '[Proforma] upload file shipping times success',
    UploadFileShippingTimesFail = '[Proforma] upload file shipping times fail',

    UploadFilePort = '[Proforma] upload file port',
    UploadFilePortPending = "[Ports] upload file port pending",
    UploadFilePortSuccess = '[Proforma] upload file port success',
    UploadFilePortFail = '[Proforma] upload file port fail',

    UploadFileShippingMarksXlsx = '[Proforma] upload file ShippingMarksXlsx',
    UploadFileShippingMarksXlsxSuccess = '[Proforma] upload file ShippingMarksXlsx success',
    UploadFileShippingMarksXlsxFail = '[Proforma] upload file ShippingMarksXlsx fail',

    UploadProcessUpdate = '[Proforma] upload file process update',
    UploadProcessSuccess = '[Proforma] upload file process success',
    UploadProcessNewSuccess = '[Proforma] upload file process new success',
    UploadProcessFail = '[Proforma] upload file process fail',

    ExportFollowDiscrepancies = '[Reports] Export all purchase summary',
    ExportFollowDiscrepanciesFail = '[Reports] Export all purchase summary fail',
    ExportFollowDiscrepanciesSuccess = '[Reports] Export all purchase summary success',
    ExportFollowDiscrepanciesUpdate = '[Reports] Export all purchase summary update',

    GetUploadAuxiliar = '[Proforma] get upload auxiliar link',
    GetUploadAuxiliarSuccess = '[Proforma] upload auxiliar link success',
    GetUploadAuxiliarFail = '[Proforma] upload auxiliar link fail',

    ExportDiscrepancies = '[Reports] Export discrepancies',
    ExportDiscrepanciesSuccess = '[Reports] Export discrepancies success',
    ExportDiscrepanciesFail = '[Reports] Export discrepancies fail',
    ExportDiscrepanciesDownload = '[Reports] Export discrepancies download',
    ExportDiscrepanciesDownloadSuccess = '[Reports] Export discrepancies download success',
    ExportDiscrepanciesDownloadFail = '[Reports] Export discrepancies download fail',

    EportShippingMarksXlsx = '[Reports] Export shipping mark',
    EportShippingMarksXlsxSuccess = '[Reports] Export shipping mark success',
    EportShippingMarksXlsxFail = '[Reports] Export shipping mark fail',
    
    LoadShippingMarksXlsx = '[Reports] Load shipping mark',
    LoadShippingMarksXlsxSuccess = '[Reports] Load shipping mark success',
    LoadShippingMarksXlsxFail = '[Reports] Load shipping mark fail',

    UploadFileShippingMarksXlsxProcess = "[Reports] Upload File shipping mark xlsx process",
    UploadFileShippingMarksXlsxProcessSuccess = "[Reports] Upload File shipping mark xlsx process sucess",
    UploadFileShippingMarksXlsxProcessFail = "[Reports] Upload File shipping mark xlsx process fail",

    Load = "[Reports] Load"
}

export class ExportDiscrepancies implements Action {
    readonly type = ReportsActionTypes.ExportDiscrepancies;
    constructor(public data: any) {}
}

export class ExportDiscrepanciesSuccess implements Action {
    readonly type = ReportsActionTypes.ExportDiscrepanciesSuccess;
    constructor(public data: any) {}
}

export class ExportDiscrepanciesFail implements Action {
    readonly type = ReportsActionTypes.ExportDiscrepanciesFail;
    constructor(public error: any) {}
}

export class ExportDiscrepanciesDownload implements Action {
    readonly type = ReportsActionTypes.ExportDiscrepanciesDownload;
    constructor(public data?: any) {}
}

export class ExportDiscrepanciesDownloadSuccess implements Action {
    readonly type = ReportsActionTypes.ExportDiscrepanciesDownloadSuccess;
    constructor(public data?: any) {}
}

export class ExportDiscrepanciesDownloadFail implements Action {
    readonly type = ReportsActionTypes.ExportDiscrepanciesDownloadFail;
    constructor(public error?: any) {}
}

export class ExportPurchaseSummarySuplier implements Action {
    readonly type = ReportsActionTypes.ExportPurchaseSummarySuplier;
    constructor(
        public FollowId: number,
        public ProviderId: number,
        public filename: string,
        public types?: string,
        public enableShipment?: string,
        public OriginId?: number,
        public RegionalId?: number,
        public exportDiscrepanciesId?: any
    ) { }
}

export class ExportPurchaseSummary implements Action {
    readonly type = ReportsActionTypes.ExportPurchaseSummary;
    constructor(
        public FollowId: number,
        public ProviderId: number,
        public filename: string,
        public types?: string,
        public enableShipment?: string,
        public OriginId?: number,
        public RegionalId?: number,
        public exportDiscrepanciesId?: any
    ) { }
}

export class ExportPurchaseSummaryFail implements Action {
    readonly type = ReportsActionTypes.ExportPurchaseSummaryFail;
    constructor(public error: any) { }
}

export class ExportPurchaseSummarySuccess implements Action {
    readonly type = ReportsActionTypes.ExportPurchaseSummarySuccess;
    constructor() { }
}

export class ExportFollowDiscrepancies implements Action {
    readonly type = ReportsActionTypes.ExportFollowDiscrepancies;
    constructor(
        public FollowId: number,
        public filename: string,
        public filter?: any
    ) { }
}

export class ExportFollowDiscrepanciesFail implements Action {
    readonly type = ReportsActionTypes.ExportFollowDiscrepanciesFail;
    constructor(public error: any) { }
}

export class ExportFollowDiscrepanciesSuccess implements Action {
    readonly type = ReportsActionTypes.ExportFollowDiscrepanciesSuccess;
    constructor(public data: any) { }
}

export class ExportFollowDiscrepanciesUpdate implements Action {
    readonly type = ReportsActionTypes.ExportFollowDiscrepanciesUpdate;
    constructor(public data: any) { }
}

export class ExportProformaList implements Action {
    readonly type = ReportsActionTypes.ExportProformaList;
    constructor(
        public FollowId: number,
        public CountryId: number,
        public filename: string,
        public user?: any
    ) { }
}

export class ExportProformaListSuccess implements Action {
    readonly type = ReportsActionTypes.ExportProformaListSuccess;
    constructor() { }
}

export class ExportProformaListFail implements Action {
    readonly type = ReportsActionTypes.ExportProformaListFail;
    constructor(public error: any) { }
}

export class GetUploadLink implements Action {
    readonly type = ReportsActionTypes.GetUploadLink;
    constructor(public file: any, public data?: any) { }
}

export class GetUploadLinkSuccess implements Action {
    readonly type = ReportsActionTypes.GetUploadLinkSuccess;
    constructor(public data: any) { }
}

export class GetUploadLinkFail implements Action {
    readonly type = ReportsActionTypes.GetUploadLinkFail;
    constructor() { }
}

export class GetUploadLinkNew implements Action {
    readonly type = ReportsActionTypes.GetUploadLinkNew;
    constructor(public file: any, public forceUpload: boolean, public FollowId?: number) { }
}

export class GetUploadLinkNewSuccess implements Action {
    readonly type = ReportsActionTypes.GetUploadLinkNewSuccess;
    constructor(public data: any) { }
}

export class GetUploadLinkNewFail implements Action {
    readonly type = ReportsActionTypes.GetUploadLinkNewFail;
    constructor() { }
}

export class GetUploadLinkNewDetailProformas implements Action {
    readonly type = ReportsActionTypes.GetUploadLinkNewDetailProformas;
    constructor(public file: any, public forceUpload: boolean, public FollowId?: number) { }
}

export class GetUploadLinkNewDetailProformasSuccess implements Action {
    readonly type = ReportsActionTypes.GetUploadLinkNewDetailProformasSuccess;
    constructor(public data: any) { }
}

export class GetUploadLinkNewDetailProformasFail implements Action {
    readonly type = ReportsActionTypes.GetUploadLinkNewDetailProformasFail;
    constructor() { }
}

export class GetUploadLinkShippingTimes implements Action {
    readonly type = ReportsActionTypes.GetUploadLinkShippingTimes;
    constructor(public file: any) { }
}

export class GetUploadLinkShippingTimesSuccess implements Action {
    readonly type = ReportsActionTypes.GetUploadLinkShippingTimesSuccess;
    constructor(public data: any) { }
}

export class GetUploadLinkShippingTimesFail implements Action {
    readonly type = ReportsActionTypes.GetUploadLinkShippingTimesFail;
    constructor() { }
}

export class GetUploadLinkPort implements Action {
    readonly type = ReportsActionTypes.GetUploadLinkPort;
    constructor(public file: any) { }
}

export class GetUploadLinkPortSuccess implements Action {
    readonly type = ReportsActionTypes.GetUploadLinkPortSuccess;
    constructor(public data: any) { }
}

export class GetUploadLinkPortFail implements Action {
    readonly type = ReportsActionTypes.GetUploadLinkPortFail;
    constructor() { }
}

export class GetUploadAuxiliar implements Action {
    readonly type = ReportsActionTypes.GetUploadAuxiliar;
    constructor(public file: any, public followId: number) { }
}

export class GetUploadAuxiliarSuccess implements Action {
    readonly type = ReportsActionTypes.GetUploadAuxiliarSuccess;
    constructor(public data: any) { }
}

export class GetUploadAuxiliarFail implements Action {
    readonly type = ReportsActionTypes.GetUploadAuxiliarFail;
    constructor() { }
}

export class UploadFile implements Action {
    readonly type = ReportsActionTypes.UploadFile;
    constructor(
        public uploadUrl: string,
        public FileId: number,
        public file: any,
        public mode?: any
    ) { }
}

export class UploadFileSuccess implements Action {
    readonly type = ReportsActionTypes.UploadFileSuccess;
    constructor(public FileId: number, public mode?: any) { }
}

export class UploadFileFail implements Action {
    readonly type = ReportsActionTypes.UploadFileFail;
    constructor() { }
}

export class UploadFileShippingMarksXlsx implements Action {
    readonly type = ReportsActionTypes.UploadFileShippingMarksXlsx;
    constructor(
        public uploadUrl: string,
        public FileId: number,
        public file: any,
    ) { }
}

export class UploadFileShippingMarksXlsxSuccess implements Action {
    readonly type = ReportsActionTypes.UploadFileShippingMarksXlsxSuccess;
    constructor(public FileId: number, public mode?: any) { }
}

export class UploadFileShippingMarksXlsxFail implements Action {
    readonly type = ReportsActionTypes.UploadFileShippingMarksXlsxFail;
    constructor() { }
}

export class UploadFileShippingMarksXlsxProcess implements Action {
    readonly type = ReportsActionTypes.UploadFileShippingMarksXlsxProcess;
    constructor(public data: any) { }
}

export class UploadFileShippingMarksXlsxProcessSuccess implements Action {
    readonly type = ReportsActionTypes.UploadFileShippingMarksXlsxProcessSuccess;
    constructor(public data: any) { }
}

export class UploadFileShippingMarksXlsxProcessFail implements Action {
    readonly type = ReportsActionTypes.UploadFileShippingMarksXlsxProcessFail;
    constructor(public data: any) { }
}


export class UploadFileNew implements Action {
    readonly type = ReportsActionTypes.UploadFileNew;
    constructor(
        public uploadUrl: string,
        public FileId: number,
        public file: any,
        public forceUpload: boolean,
        public FollowId?: number
    ) { }
}

export class UploadFileNewSuccess implements Action {
    readonly type = ReportsActionTypes.UploadFileNewSuccess;
    constructor(public file: any, public FileId: any, public forceUpload: boolean, public FollowId?: number) { }
}

export class UploadFileNewFail implements Action {
    readonly type = ReportsActionTypes.UploadFileNewFail;
    constructor() { }
}

export class UploadFileNewDetailProformas implements Action {
    readonly type = ReportsActionTypes.UploadFileNewDetailProformas;
    constructor(
        public uploadUrl: string,
        public FileId: number,
        public file: any,
        public forceUpload: boolean,
        public FollowId?: number
    ) { }
}

export class UploadFileNewDetailProformasSuccess implements Action {
    readonly type = ReportsActionTypes.UploadFileNewDetailProformasSuccess;
    constructor(public file: any, public FileId: any, public forceUpload: boolean, public FollowId?: number) { }
}

export class UploadFileNewDetailProformasFail implements Action {
    readonly type = ReportsActionTypes.UploadFileNewDetailProformasFail;
    constructor() { }
}

export class UploadFilePort implements Action {
    readonly type = ReportsActionTypes.UploadFilePort;
    constructor(
        public uploadUrl: string,
        public FileId: number,
        public file: any,
    ) { }
}

export class UploadFilePortSuccess implements Action {
    readonly type = ReportsActionTypes.UploadFilePortSuccess;
    constructor(public file: any, public FileId: any) { }
}

export class UploadFilePortFail implements Action {
    readonly type = ReportsActionTypes.UploadFilePortFail;
    constructor() { }
}

export class UploadFileShippingTimes implements Action {
    readonly type = ReportsActionTypes.UploadFileShippingTimes;
    constructor(
        public uploadUrl: string,
        public FileId: number,
        public file: any,
    ) { }
}

export class UploadFileShippingTimesSuccess implements Action {
    readonly type = ReportsActionTypes.UploadFileShippingTimesSuccess;
    constructor(public file: any, public FileId: any) { }
}

export class UploadFileShippingTimesFail implements Action {
    readonly type = ReportsActionTypes.UploadFileShippingTimesFail;
    constructor() { }
}

export class UploadProcessUpdate implements Action {
    readonly type = ReportsActionTypes.UploadProcessUpdate;
    constructor(public data: any) { }
}

export class UploadProcessSuccess implements Action {
    readonly type = ReportsActionTypes.UploadProcessSuccess;
    constructor() { }
}

export class UploadProcessNewSuccess implements Action {
    readonly type = ReportsActionTypes.UploadProcessNewSuccess;
    constructor() { }
}


export class UploadProcessFail implements Action {
    readonly type = ReportsActionTypes.UploadProcessFail;
    constructor() { }
}

export class EportShippingMarksXlsx implements Action {
    readonly type = ReportsActionTypes.EportShippingMarksXlsx;
    constructor(public businessUnits: any) {}
}

export class EportShippingMarksXlsxSuccess implements Action {
    readonly type = ReportsActionTypes.EportShippingMarksXlsxSuccess;
    constructor() {}
}

export class EportShippingMarksXlsxFail implements Action {
    readonly type = ReportsActionTypes.EportShippingMarksXlsxFail;
    constructor(public error: any) {}
}

export class LoadShippingMarksXlsx implements Action {
    readonly type = ReportsActionTypes.LoadShippingMarksXlsx;
    constructor(public file: any) {}
}

export class LoadShippingMarksXlsxSuccess implements Action {
    readonly type = ReportsActionTypes.LoadShippingMarksXlsxSuccess;
    constructor() {}
}

export class LoadShippingMarksXlsxFail implements Action {
    readonly type = ReportsActionTypes.LoadShippingMarksXlsxFail;
    constructor(public error: any) {}
}

export class Load implements Action {
    readonly type = ReportsActionTypes.Load;
    constructor() {}
}


export type ReportsActionsUnion =
    | ExportPurchaseSummarySuplier
    | ExportPurchaseSummary
    | ExportPurchaseSummaryFail
    | ExportPurchaseSummarySuccess
    | ExportProformaList
    | ExportProformaListSuccess
    | ExportProformaListFail
    | GetUploadLink
    | GetUploadLinkSuccess
    | GetUploadLinkFail
    | GetUploadLinkNew
    | GetUploadLinkNewSuccess
    | GetUploadLinkNewFail
    | GetUploadLinkNewDetailProformas
    | GetUploadLinkNewDetailProformasSuccess
    | GetUploadLinkNewDetailProformasFail
    | GetUploadLinkShippingTimes
    | GetUploadLinkShippingTimesSuccess
    | GetUploadLinkShippingTimesFail
    | GetUploadLinkPort
    | GetUploadLinkPortSuccess
    | GetUploadLinkPortFail
    | UploadFileShippingTimes
    | UploadFileShippingTimesSuccess
    | UploadFileShippingTimesFail
    | UploadFilePort
    | UploadFilePortSuccess
    | UploadFilePortFail
    | UploadFile
    | UploadFileSuccess
    | UploadFileFail
    | UploadFileNew
    | UploadFileNewSuccess
    | UploadFileNewFail
    | UploadFileNewDetailProformas
    | UploadFileNewDetailProformasSuccess
    | UploadFileNewDetailProformasFail
    | UploadProcessUpdate
    | UploadProcessSuccess
    | UploadProcessNewSuccess
    | UploadProcessFail
    | ExportFollowDiscrepancies
    | ExportFollowDiscrepanciesFail
    | ExportFollowDiscrepanciesSuccess
    | ExportFollowDiscrepanciesUpdate
    | GetUploadAuxiliar
    | GetUploadAuxiliarSuccess
    | GetUploadAuxiliarFail
    | ExportDiscrepancies
    | ExportDiscrepanciesSuccess
    | ExportDiscrepanciesFail
    | ExportDiscrepanciesDownload
    | ExportDiscrepanciesDownloadSuccess
    | ExportDiscrepanciesDownloadFail
    | EportShippingMarksXlsx
    | EportShippingMarksXlsxSuccess
    | EportShippingMarksXlsxFail
    | LoadShippingMarksXlsx
    | LoadShippingMarksXlsxSuccess
    | LoadShippingMarksXlsxFail
    | UploadFileShippingMarksXlsx
    | UploadFileShippingMarksXlsxSuccess
    | UploadFileShippingMarksXlsxFail
    | UploadFileShippingMarksXlsxProcess
    | UploadFileShippingMarksXlsxProcessSuccess
    | UploadFileShippingMarksXlsxProcessFail
    | Load;
